import React from 'react';

import { PhotosScreen } from '~/components/domain/photos/PhotosScreen';

export default function FavoritePhotos() {
  return <PhotosScreen listType="favorites" />;
}
